import type { BotsApi } from './types';

export async function getBotsApi(): Promise<BotsApi> {
	const botsApi = await import('./endpoints');
	return botsApi;
}
